// this is temporary on core swag, going to be moved to swag-space-x shortly
import React from 'react';
import classes from './reseller-colored-frame.scss';
export const ResellerColoredFrame = ({
  user,
  onButtonClick
}) => {
  const labelText = `You are currently browsing as ${user.email}`;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.top
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.right
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bottom
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.left
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.labelContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.labelText
  }, labelText), /*#__PURE__*/React.createElement("button", {
    onClick: onButtonClick,
    className: classes.exitButton
  }, "Exit")));
};